const ENGLISH_LOCALE_BRITISH = 'en_GB'
const ENGLISH_LOCALE_DEV = 'en_dev'
const ENGLISH_LOCALE = 'en'
const FRENCH_LOCALE = 'fr'
const GERMAN_LOCALE = 'de'
const ITALIAN_LOCALE = 'it'
const SPANISH_LOCALE = 'es'
const POLISH_LOCALE = 'pl'
const PORTUGUESE_LOCALE = 'pt'
const SWEDISH_LOCALE = 'sv'
const UKRAINIAN_LOCALE = 'uk'

const DEFAULT_SUBDOMAIN = 'www'

const LOCALE_TO_SUBDOMAIN_MAPPING = {
  [ENGLISH_LOCALE]: DEFAULT_SUBDOMAIN,
  [ENGLISH_LOCALE_BRITISH]: 'uk',
  [ENGLISH_LOCALE_DEV]: DEFAULT_SUBDOMAIN,
  [FRENCH_LOCALE]: 'fr',
  [GERMAN_LOCALE]: 'de',
  [ITALIAN_LOCALE]: 'it',
  [POLISH_LOCALE]: 'pl',
  [PORTUGUESE_LOCALE]: 'pt',
  [SPANISH_LOCALE]: 'es',
  [SWEDISH_LOCALE]: 'se',
  [UKRAINIAN_LOCALE]: 'ua',
}

const LOCALE_TO_ZENDESK_MAPPING = {
  [ENGLISH_LOCALE]: 'en-us',
  [ENGLISH_LOCALE_BRITISH]: 'en-gb',
  [ENGLISH_LOCALE_DEV]: 'en-gb',
  [FRENCH_LOCALE]: 'fr',
  [GERMAN_LOCALE]: 'de',
  [ITALIAN_LOCALE]: 'it',
  [POLISH_LOCALE]: 'pl',
  [PORTUGUESE_LOCALE]: 'pt-br',
  [SPANISH_LOCALE]: 'es',
  [SWEDISH_LOCALE]: 'sv',
  [UKRAINIAN_LOCALE]: 'uk',
}

const getSubdomainFromLocale = (locale) => LOCALE_TO_SUBDOMAIN_MAPPING[locale] || DEFAULT_SUBDOMAIN // added www as a default

// https://developers.google.com/recaptcha/docs/language
const RECAPTCHA_LOCALE_EXCEPTIONS = {
  [ENGLISH_LOCALE_BRITISH]: 'en-GB',
  [ENGLISH_LOCALE_DEV]: ENGLISH_LOCALE,
}

// https://docs.hcaptcha.com/languages
const HCAPTCHA_LOCALE_EXCEPTIONS = {
  [ENGLISH_LOCALE_BRITISH]: 'en',
  [ENGLISH_LOCALE_DEV]: ENGLISH_LOCALE,
}

const CAPTCHA_LOCALE_EXCEPTIONS_MAPPING = {
  hcaptcha: HCAPTCHA_LOCALE_EXCEPTIONS,
  recaptcha: RECAPTCHA_LOCALE_EXCEPTIONS,
}

const getCaptchaLocale = (locale, provider) =>
  CAPTCHA_LOCALE_EXCEPTIONS_MAPPING[provider][locale] || locale

export {
  CAPTCHA_LOCALE_EXCEPTIONS_MAPPING,
  ENGLISH_LOCALE,
  ENGLISH_LOCALE_BRITISH,
  ENGLISH_LOCALE_DEV,
  FRENCH_LOCALE,
  GERMAN_LOCALE,
  getCaptchaLocale,
  getSubdomainFromLocale,
  ITALIAN_LOCALE,
  LOCALE_TO_ZENDESK_MAPPING,
  POLISH_LOCALE,
  PORTUGUESE_LOCALE,
  SPANISH_LOCALE,
  SWEDISH_LOCALE,
  UKRAINIAN_LOCALE,
}
